import { render, staticRenderFns } from "./CreateCategoryDialog.vue?vue&type=template&id=0f62903c&scoped=true"
import script from "./CreateCategoryDialog.vue?vue&type=script&lang=js"
export * from "./CreateCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCategoryDialog.vue?vue&type=style&index=0&id=0f62903c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62903c",
  null
  
)

export default component.exports